import StorageHelper from "../helpers/StorageHelper";
import { history } from "./index";

class SessionService {
  constructor() {
    this.storageHelper = new StorageHelper();
  }

  getUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    return dados.usuario;
  }

  getEmpresa() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    return dados.empresa;
  }

  getConfiguracoes() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    return dados.empresa?.configuracoes || null;
  }

  getEmpresaRelatorio() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    const empresa = dados.empresa;
    return {
      imagemLogo: empresa.imagemLogo,
      razaoSocial: empresa.razaoSocial,
      fantasia: empresa.fantasia,
      cnpjCpf: empresa.cnpjCpf,
      enderecoLogradouro: empresa.enderecoLogradouro,
      enderecoLogradouroNumero: empresa.enderecoLogradouroNumero,
      enderecoBairro: empresa.enderecoBairro,
      enderecoCidade: empresa.enderecoCidade,
      enderecoCep: empresa.enderecoCep,
      enderecoUF: empresa.enderecoUF,
      telefone: empresa.telefone,
    };
  }

  setEmpresa(empresa) {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa = empresa;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
    try {
      if (typeof window !== "undefined" && window.dispatchEvent) {
        window.dispatchEvent(
          new CustomEvent("session:updated", { detail: dados }),
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  setConfiguracoesEmpresa(configuracoesData) {
    const configuracoes = {
      diasVencimentoOrcamento: configuracoesData.diasVencimentoOrcamento,
      diasVencimentoOrcamentoServico:
        configuracoesData.diasVencimentoOrcamentoServico,
      limiteCredito: configuracoesData.limiteCredito,
      inadimplencia: configuracoesData.inadimplencia,
      operacaoFiscalPdvPadraoId: configuracoesData.operacaoFiscalPdvPadraoId,
      operacaoFiscalPdvSecundariaId:
        configuracoesData.operacaoFiscalPdvSecundariaId,
      operacaoFiscalVendasPadraoId:
        configuracoesData.operacaoFiscalVendasPadraoId,
      operacaoFiscalMdfePadraoId: configuracoesData.operacaoFiscalMdfePadraoId,
      operacaoFiscalComprasPadraoId:
        configuracoesData.operacaoFiscalComprasPadraoId,
      cfopComprasPadraoId: configuracoesData.cfopComprasPadraoId,
      precificacaoNfEntrada: configuracoesData.precificacaoNfEntrada,
      margemCalculo: configuracoesData.margemCalculo,
      visualizarImpressaoEmissao: configuracoesData.visualizarImpressaoEmissao,
      obrigatoriedadeMeioPagamento:
        configuracoesData.obrigatoriedadeMeioPagamento,
      lembreteAntecedenciaServico:
        configuracoesData.lembreteAntecedenciaServico,
      descontoVendaItem: configuracoesData.descontoVendaItem,
      despesaVendaItem: configuracoesData.despesaVendaItem,
      freteVendaItem: configuracoesData.freteVendaItem,
      zerarSaldoAnteriorCaixa: configuracoesData.zerarSaldoAnteriorCaixa,
      utilizarSuprimentoSangria: configuracoesData.utilizarSuprimentoSangria,
      exibirDescricaoServico: configuracoesData.exibirDescricaoServico,
      buscaProdutosCodigoBarras: configuracoesData.buscaProdutosCodigoBarras,
      inicialCodigoBarrasBalanca: configuracoesData.inicialCodigoBarrasBalanca,
      leituraPadraoBalanca: configuracoesData.leituraPadraoBalanca,
      vendaEstoqueNegativo: configuracoesData.vendaEstoqueNegativo,
      impressoraEtiqueta: configuracoesData.impressoraEtiqueta,
      impressoraTermica: configuracoesData.impressoraTermica,
      impressaoDiretaNf: configuracoesData.impressaoDiretaNf,
      impressaoDiretaOrcamentos: configuracoesData.impressaoDiretaOrcamentos,
      impressaoDiretaPedidos: configuracoesData.impressaoDiretaPedidos,
      confirmacaoImpressaoNf: configuracoesData.confirmacaoImpressaoNf,
      modalidadeComissao: configuracoesData.modalidadeComissao,
      confirmacaoImpressaoOrcamentos:
        configuracoesData.confirmacaoImpressaoOrcamentos,
      confirmacaoImpressaoPedidos:
        configuracoesData.confirmacaoImpressaoPedidos,
      confirmacaoImpressaoOrcamentoServico:
        configuracoesData.confirmacaoImpressaoOrcamentoServico,
      impressaoDiretaOs: configuracoesData.impressaoDiretaOs,
      modeloImpressaoPadraoOrcamentosServicos:
        configuracoesData.modeloImpressaoPadraoOrcamentosServicos,
      modeloImpressaoPadraoOs: configuracoesData.modeloImpressaoPadraoOs,
      confirmacaoImpressaoOrcamentosServicos:
        configuracoesData.confirmacaoImpressaoOrcamentosServicos,
      impressaoDiretaOrcamentosServicos:
        configuracoesData.impressaoDiretaOrcamentosServicos,
      vendedorPorItemServico: configuracoesData.vendedorPorItemServico,
      planoFinanceiroDescontoNfSaidaId:
        configuracoesData.planoFinanceiroDescontoNfSaidaId,
      planoFinanceiroJurosRecebidosId:
        configuracoesData.planoFinanceiroJurosRecebidosId,
      planoFinanceiroMultaRecebidaId:
        configuracoesData.planoFinanceiroMultaRecebidaId,
      diasSemanaFuncionamento: configuracoesData.diasSemanaFuncionamento,
      intervaloAgendamentos: configuracoesData.intervaloAgendamentos,
      exibirReferenciaPecaServico:
        configuracoesData.exibirReferenciaPecaServico,
      exibirPagamentoSemBaixa: configuracoesData.exibirPagamentoSemBaixa,
      modeloImpressaoPadraoReciboServico:
        configuracoesData.modeloImpressaoPadraoReciboServico,
      impressaoDiretaReciboServico:
        configuracoesData.impressaoDiretaReciboServico,
      excluirHistoricoPagamentos: configuracoesData.excluirHistoricoPagamentos,
      meioPagamentosPadroesConfiguracoes:
        configuracoesData.meioPagamentosPadroesConfiguracoes.map(
          (meioPagamentoConfiguracao) => {
            return {
              id: meioPagamentoConfiguracao.id,
              config: meioPagamentoConfiguracao.configuracaoId,
              meioPa: meioPagamentoConfiguracao.meioPagamentoId,
              pct_co: meioPagamentoConfiguracao.pct_configuracao_id,
            };
          },
        ),
      faturamentoMensal: configuracoesData.faturamentoMensal,
      emailPersonalizado: configuracoesData.emailPersonalizado,
      enviarBoletoAposEmissao: configuracoesData.enviarBoletoAposEmissao,
    };
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa.configuracoes = configuracoes;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
    dispatchEvent(dados);
  }

  setUsuario(usuario) {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.usuario = usuario;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
    dispatchEvent(dados);
  }

  getEmpresaAndUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    return JSON.parse(dadosSession);
  }

  getPermisoes() {
    const dadosSession = this.storageHelper.getLocal("dados");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      return dados.usuario.perfilUsuario.permisoes;
    }
    return [];
  }

  setToken(token) {
    this.storageHelper.setLocal("token", token);
  }

  setSession(data) {
    this.storageHelper.setLocal("token", data.token);
    this.storageHelper.setLocal("dados", JSON.stringify(data.dados));
    dispatchEvent(data.dados);
  }

  setChatSessionId(id) {
    this.storageHelper.setLocal("chat_session_id", id);
  }

  getChatSessionId() {
    return this.storageHelper.getLocal("chat_session_id");
  }

  removeChatSessionId() {
    this.storageHelper.removeLocal("chat_session_id");
  }

  deslogar() {
    this.storageHelper.removeLocal("token");
    this.storageHelper.removeLocal("rotinas");
    this.storageHelper.removeLocal("theme");
    this.storageHelper.removeLocal("dados");
    this.storageHelper.removeLocal("chat_session_id");
    this.storageHelper.removeSession("notificacao");
    history.push("/login");
  }
}

function dispatchEvent(dados) {
  try {
    if (typeof window !== "undefined" && window.dispatchEvent) {
      window.dispatchEvent(
        new CustomEvent("session:updated", { detail: dados }),
      );
    }
  } catch (err) {
    console.error(err);
  }
}

export default SessionService;
